import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap-5';

import ProgressCircle from 'components/project/progress_circle';
import { USD } from 'helpers/formatters/number_formats';
import { formatDate } from 'helpers/formatters/date_time_formats';

export default class PredictionSummary extends React.Component {
  static propTypes = {
    closeDate: PropTypes.string,
    dateLikelyToClose: PropTypes.string,
    estimatedGrossCommission: PropTypes.number,
    listingStatus: PropTypes.string.isRequired,
    percentageLikelyToClose: PropTypes.number,
    voucher: PropTypes.shape({
      grossCommissionAmount: PropTypes.number
    })
  };

  listingIsClosed = () => this.props.listingStatus === 'closed';

  renderPercentage = () => {
    const { dateLikelyToClose, percentageLikelyToClose } = this.props;

    if (percentageLikelyToClose && percentageLikelyToClose > 0) {
      return (
        <div className="d-flex align-items-center gap-2">
          <div className="d-inline-block align-middle">
            <ProgressCircle percentage={percentageLikelyToClose} size="xs" />
          </div>
          <span>likely to close{dateLikelyToClose ? ` on ${formatDate(dateLikelyToClose)}` : ''}</span>
        </div>
      );
    }

    if (dateLikelyToClose) return <strong>Likely to close on {formatDate(dateLikelyToClose)}</strong>;

    return <span className="text-muted" name="no-prediction">no prediction</span>;
  }

  renderCloseDate = () => {
    if (!this.props.closeDate) return <div className="text-center">Closed</div>;

    return (
      <div className="text-center">
        Closed on <strong>{formatDate(this.props.closeDate)}</strong>
      </div>
    );
  }

  renderCommission = () => {
    const { estimatedGrossCommission, voucher } = this.props;
    const listingIsClosed = this.listingIsClosed();
    const name = listingIsClosed ? 'gross-commission-amount' : 'estimated-gross-commission';
    const commission = listingIsClosed ? voucher.grossCommissionAmount : estimatedGrossCommission;
    const prefix = listingIsClosed ? '' : ' est.';

    if (commission == null) return <span className="text-muted" name={`no-${name}`}>no {prefix}gross commission</span>;

    return (
      <React.Fragment>
        <strong name={name}>{USD.format(commission, { round: true })}</strong>
        <span>{prefix} gross commission</span>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Row className="align-items-center">
        <Col className="text-center" lg={6} md={12} sm={6} xs={12}>
          {this.listingIsClosed() ? this.renderCloseDate() : this.renderPercentage()}
        </Col>
        <Col className="text-center border-start" lg={6} md={12} sm={6} xs={12}>
          {this.renderCommission()}
        </Col>
      </Row>
    );
  }
}
